import React from "react";

import { StyledSVG } from "../StyledIcon";

export const DiscordIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <mask id="mask0_3295_282" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill={iconColor}/>
      </mask>
      <g mask="url(#mask0_3295_282)">
        <path d="M27.5581 29.5635L21.1116 23.7889L21.8852 26.0987H6.06977C5.25561 26.0987 4.47481 25.7945 3.89911 25.2531C3.32342 24.7116 3 23.9772 3 23.2114V5.88734C3 5.12157 3.32342 4.38716 3.89911 3.84568C4.47481 3.3042 5.25561 3 6.06977 3H24.4884C25.3025 3 26.0833 3.3042 26.659 3.84568C27.2347 4.38716 27.5581 5.12157 27.5581 5.88734V29.5635ZM15.2791 9.69863C11.9883 9.69863 9.67981 11.0268 9.67981 11.0268C10.9446 9.96427 13.1548 9.35215 13.1548 9.35215L12.946 9.15581C10.8709 9.19046 8.99219 10.5417 8.99219 10.5417C6.88019 14.688 7.01526 18.2683 7.01526 18.2683C8.73433 20.3587 11.2884 20.2086 11.2884 20.2086L12.1602 19.1691C10.6253 18.8573 9.65526 17.5753 9.65526 17.5753C9.65526 17.5753 11.9637 19.0536 15.2791 19.0536C18.5944 19.0536 20.9029 17.5753 20.9029 17.5753C20.9029 17.5753 19.9328 18.8573 18.398 19.1691L19.2698 20.2086C19.2698 20.2086 21.8238 20.3587 23.5429 18.2683C23.5429 18.2683 23.678 14.688 21.566 10.5417C21.566 10.5417 19.6873 9.19046 17.6121 9.15581L17.4033 9.35215C17.4033 9.35215 19.6136 9.96427 20.8783 11.0268C20.8783 11.0268 18.5699 9.69863 15.2791 9.69863ZM12.7373 14.0758C13.5354 14.0758 14.1862 14.7342 14.174 15.5426C14.174 16.3395 13.5354 17.0094 12.7373 17.0094C11.9514 17.0094 11.3129 16.3395 11.3129 15.5426C11.3129 14.7342 11.9392 14.0758 12.7373 14.0758ZM17.8577 14.0758C18.6558 14.0758 19.2943 14.7342 19.2943 15.5426C19.2943 16.3395 18.6558 17.0094 17.8577 17.0094C17.0718 17.0094 16.4333 16.3395 16.4333 15.5426C16.4333 14.7342 17.0595 14.0758 17.8577 14.0758Z" fill={iconColor}
        vector-effect="non-scaling-stroke"
        />
      </g>
    </StyledSVG>
  );
};
